import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import StorageService from "../util/storage";

const OrganizationFetcher = () => {
    const navigate = useNavigate();

    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        // if (!hasFetched) {
            // Fetch organization data using the hostname
            const hostname = window.location.host;
            axios
                .get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/organisations?filters[hostnames][url][$eq]=${hostname}&filters[hostnames][type][$eq]=LMS&populate[hostnames]=*`
                )
                .then((response) => {
                    // Handle successful response, maybe store organization data in state or context
                    if (response.data.data.length === 0) {
                        navigate("/not-found");
                    }
                    const organization = response.data.data[0];
                    const orgId = organization.attributes.orgId;
                    const orgSlug = organization.attributes.slug;
                    StorageService.setItem("organisationId", orgId);
                    StorageService.setItem("organisationSlug", orgSlug);
                    StorageService.setItem("organisation", organization);
                    setHasFetched(true);
                })
                .catch((error) => {
                    navigate("/not-found");
                });
        // }
    }, []);

    // Render loading indicator or nothing, as this component is just for fetching data
    return null;
};

export default OrganizationFetcher;
